import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsxs("g", {
		fill: "#2B2B2B",
		fillRule: "evenodd",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M8 16c1.45 0 2.795-.363 4.032-1.088a8.099 8.099 0 0 0 2.88-2.88A7.833 7.833 0 0 0 16 8c0-1.45-.363-2.795-1.088-4.032a8.099 8.099 0 0 0-2.88-2.88A7.833 7.833 0 0 0 8 0C6.55 0 5.205.363 3.968 1.088a8.099 8.099 0 0 0-2.88 2.88A7.833 7.833 0 0 0 0 8c0 1.45.363 2.795 1.088 4.032a8.099 8.099 0 0 0 2.88 2.88A7.833 7.833 0 0 0 8 16zm0-1.264a6.544 6.544 0 0 1-3.392-.928 6.408 6.408 0 0 1-2.416-2.416A6.544 6.544 0 0 1 1.264 8c0-1.216.31-2.347.928-3.392a6.408 6.408 0 0 1 2.416-2.416A6.544 6.544 0 0 1 8 1.264c1.216 0 2.347.31 3.392.928a6.408 6.408 0 0 1 2.416 2.416A6.544 6.544 0 0 1 14.736 8c0 1.216-.31 2.347-.928 3.392a6.408 6.408 0 0 1-2.416 2.416A6.544 6.544 0 0 1 8 14.736z",
				fillRule: "nonzero"
			}),
			/* @__PURE__ */ _jsx("circle", {
				fillRule: "nonzero",
				cx: 8,
				cy: 4.6,
				r: 1
			}),
			/* @__PURE__ */ _jsx("path", { d: "M7 6.6h2v6H7z" })
		]
	})
});
export default SvgInfo;
